import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Discount, DiscountType } from '@vendasta/marketplace-apps';
import { formatDisplayPrice } from '@vendasta/shared';
import { FormatDatePipe, formatDate, formatting } from './format-date.pipe';

@Component({
  selector: 'billing-ui-discount-display',
  templateUrl: './discount-display.component.html',
  styleUrls: ['./discount-display.component.scss'],
  providers: [FormatDatePipe],
})
export class DiscountDisplayComponent implements OnInit, OnChanges {
  @Input() discounts: Discount[] = [];
  @Input() currency = 'USD';
  @Input() size: 'regular' | 'large' = 'regular';

  multipleDiscounts = false;
  discountsFormatted: string[] = [];
  ngOnInit(): void {
    this.ngOnChanges();
  }

  ngOnChanges(): void {
    if (this.discounts.length > 1) {
      this.multipleDiscounts = true;
    } else {
      this.multipleDiscounts = false;
    }
    this.formatDiscounts();
  }

  formatDiscounts(): void {
    this.discountsFormatted = [];
    for (const index of Object.keys(this.discounts)) {
      const discount = this.discounts[index];
      const startDate = formatDate(discount.start, formatting.date, '', true);
      const price = formatDisplayPrice(discount.amount, this.currency, null, true, false, true, false);

      let formattedEndDate = '';

      if (discount.end && discount.end != '') {
        formattedEndDate = ' to ' + formatDate(discount.end, formatting.date, '', true);
      }

      switch (discount.discountType) {
        case DiscountType.DISCOUNT_TYPE_PERCENT_AMOUNT:
          this.discountsFormatted.push(discount.amount + '% off starting ' + startDate + formattedEndDate);
          break;
        case DiscountType.DISCOUNT_TYPE_FIXED_AMOUNT:
          this.discountsFormatted.push(price + ' off starting ' + startDate + formattedEndDate);
          break;
        case DiscountType.DISCOUNT_TYPE_FIXED_NUMBER_OF_UNITS:
          if (discount.amount === 1) {
            this.discountsFormatted.push(
              discount.amount + ' free unit per period starting ' + startDate + formattedEndDate,
            );
            break;
          }
          this.discountsFormatted.push(
            discount.amount + ' free units per period starting ' + startDate + formattedEndDate,
          );
          break;
        case DiscountType.DISCOUNT_TYPE_FIXED_AMOUNT_PER_UNIT:
          this.discountsFormatted.push(price + ' off each unit starting ' + startDate + formattedEndDate);
          break;
        default:
          break;
      }
    }
  }
}
